// extracted by css-extract-rspack-plugin
export default {"AvatarStack":"assignees-group-header-label-module__AvatarStack__U5_FJ","AggregateLabels":"assignees-group-header-label-module__AggregateLabels__4wS3S"};